module.exports = "<div class=\"check-off-history-item\">\n\t<div class=\"completed-date pull-right\">\n\t\t{{getCompletedDate()}}\n\t</div>\n\t{{getItemName()}}\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/checkoffs/check-off-history-item/check-off-history-item.component.html
// module id = ./src/app/checkoffs/check-off-history-item/check-off-history-item.component.html
// module chunks = 0